import type { Action } from '../App/types';
import * as ActionTypes from './constants';
import type { HomeState } from './types';

const initialState = {
  assignees: [],
  activities: [],
  currentUser: undefined,
  selectedProperty: undefined,
  selectedAssignee: '',
  activeKey: '1',
  taskInformation: {
    renewalsInProcess: [],
    transfersInProcess: [],
    scheduledMoveOuts: [],
    pendingFAS: [],
    openWorkOrders: [],
    scheduledMoveIns: [],
    applicationsInProcess: [],
    prospectsToFollowUp: [],
    leaseStats: [],
  },
  duplicateProspects: null,
  isDuplicatesLoading: false,
};

const homeReducer = (state: HomeState = initialState, action: Action<*, *>) => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.GET_ALL_ACTIVITIES_BY_ASSIGNEE_SUCCESS: {
      return { ...state, activities: payload };
    }
    case ActionTypes.CLEAR_ACTIVITIES_BY_ASSIGNEE: {
      return { ...state, activities: [] };
    }
    case ActionTypes.SET_SELECTED_ASSIGNEE: {
      return { ...state, selectedAssignee: payload };
    }
    case ActionTypes.SET_ACTIVE_KEY: {
      return { ...state, activeKey: payload };
    }
    case ActionTypes.CLEAR_TASK_INFORMATION: {
      return { ...state, taskInformation: { ...initialState.taskInformation } };
    }
    case ActionTypes.GET_TASK_INFORMATION_SUCCESS: {
      return { ...state, taskInformation: payload };
    }
    case ActionTypes.GET_DUPLICATE_PROSPECTS: {
      return { ...state, isDuplicatesLoading: true };
    }
    case ActionTypes.GET_DUPLICATE_PROSPECTS_SUCCESS: {
      return {
        ...state,
        duplicateProspects: payload,
        isDuplicatesLoading: false,
      };
    }
    case ActionTypes.GET_DUPLICATE_PROSPECTS_ERROR: {
      return { ...state, isDuplicatesLoading: false };
    }
    case ActionTypes.REMOVE_DUPLICATE_FROM_LIST: {
      if (!state.duplicateProspects) return state;
      return {
        ...state,
        duplicateProspects: state.duplicateProspects.filter(
          (duplicate) => duplicate.id !== payload.id,
        ),
      };
    }
    default:
      return state;
  }
};

export default homeReducer;
